import { API } from "../../config";

export const getAllUpdates = async () => {
  const response = await API.get("/update");
  return response?.data?.data;
};
export const getAllFAQs = async () => {
  const response = await API.get("/faq");
  return response?.data?.data;
};
export const AddTestimonial = async (data: {
  position: string;
  testimonial_description: string;
}) => {
  const response = await API.post("/testimonial", data);
  return response?.data;
};
export const GetTestimonials = async () => {
  const response = await API.get("/testimonial");
  return response?.data?.data;
};
export const GetAllDocuments = async () => {
  const response = await API.get("/documents");
  return response?.data?.data;
};

export const RegenerateShareToken = async (id: string | undefined) => {
  const response = await API.post(`/share/${id}/regenerate`);
  return response?.data;
};
